import { memo } from 'react'

import CustomImage from '../images/image'
import { generateRandomLightColor } from 'utils/randomColor'

const CulturesCard = ({ cards }) =>
  cards.map(card => (
    <div className="cultures-card-container" key={card.id}>
      <div
        className="cultures-card-images-container"
        style={{
          background: generateRandomLightColor(card.id)
        }}
      >
        <div className="cultures-card-images">
          <CustomImage
            media={card.slide.data.attributes}
            layout="fill"
            objectFit="contain"
          />
        </div>
      </div>
      <div className="cultures-card-content-container">
        <div className="cultures-card-title">{card.title}</div>
        <div className="cultures-card-content">{card.description}</div>
      </div>
    </div>
  ))

export default memo(CulturesCard)
